// extracted by mini-css-extract-plugin
module.exports = {"component":"Read_component__3TCtW","small":"Read_small__3ESo5","block":"Read_block__3w_om"};